import React from 'react'
import BgSpa from "../../images/hotelSpaBg.png"
import Increment from "../../images/increment.svg"
import Decrement from "../../images/decrement.svg"

function SpaRequest(props) {
    return (
        <div>
            <div className="mb-28">
                <img className='w-screen sm:h-[230px] h-[117px]' src={BgSpa} alt='bgHotelguide' />
                <div className="section-wrap mx-4 mt-6 sm:mt-14">
                    <div className="guestName sm:text-center text-left">
                        Request
                    </div>
                    <div className='mt-6 text-base font-semibold'>Paraffin-Body Wrap</div>
                    <form className='flex flex-col'>
                        <label className='mt-4 text-left text-[#D0D0D0] text-12px font-normal'>Occupancy</label>
                        <div className='mt-2 reqInput flex items-center justify-between'>
                            <div className='text-sm font-medium'>1 Person</div>
                            <div className='flex  space-x-6 items-center'>
                                <img src={Increment} />
                                <img src={Decrement} />
                            </div>
                        </div>
                        <label className='mt-4 text-left text-[#D0D0D0] text-12px font-normal'>Preferred date</label>
                        <input className='mt-2 reqInput'  type="date" name="" id="" />
                        <label className='mt-4 text-left text-[#D0D0D0] text-12px font-normal'>Preferred Time</label>
                        <input className='mt-2 reqInput' type="time" name="" id="" />
                        <label className='mt-4 text-left text-[#D0D0D0] text-12px font-normal'>Comment if any</label>
                        <textarea className='mt-2 reqInput' type="textarea" name="" id="" />
                        <button className='bookBtn mt-10 max-w-[400px]'>Book Now</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default SpaRequest
